import type { ReferenceRendererProps } from '@contember/react-client'
import clsx from 'clsx'
import React from 'react'
import type { ContentBlockReference } from '../../app/data/content/ContentFragment'
import { Configurator } from '../../neon/configurator/Configurator'
import {
	ConfiguratorInfoContext,
	toConfiguratorInfoContext,
} from '../../neon/contember/transformers'
import { IfHydrated } from '../../packages/@necktip/next/hydratation'
import { Container } from '../Container'

export const configurator = function ConfiguratorBlock({
	reference,
}: ReferenceRendererProps<ContentBlockReference>) {
	const { presetValue } = reference

	if (!presetValue) {
		throw new Error('Missing presetValue')
	}

	const { preset } = presetValue

	if (!preset) {
		throw new Error('Missing preset')
	}

	const context = React.useMemo(() => toConfiguratorInfoContext(preset), [preset])

	return (
		<IfHydrated
			yes={() => (
				<section className={clsx('section', 'configurator')}>
					<Container>
						<h2 className="sectionTitle">{reference.primaryText}</h2>
						<ConfiguratorInfoContext.Provider value={context}>
							{context && <Configurator />}
						</ConfiguratorInfoContext.Provider>
					</Container>
				</section>
			)}
		/>
	)
}
